export var ContractType;
(function (ContractType) {
    ContractType["Freelancer"] = "Freelancer";
    ContractType["Seconded"] = "Seconded";
})(ContractType || (ContractType = {}));
/** Explicit options so the Contract type dropdown always shows Freelancer and Seconded */
export const ContractTypeOptions = [
    { label: ContractType.Freelancer, value: ContractType.Freelancer },
    { label: ContractType.Seconded, value: ContractType.Seconded }
];
